import { z } from 'zod';

/**
 * Stable, machine-readable error codes. The frontend switches on these; messages are for humans
 * and may change. Never put internal details (SQL, stack traces, provider responses) in `message`.
 */
export const ERROR_CODES = [
  'VALIDATION_ERROR',
  'UNAUTHENTICATED',
  'FORBIDDEN',
  'NOT_FOUND',
  'CONFLICT',
  'RATE_LIMITED',
  'CSRF_INVALID',
  'EMAIL_NOT_VERIFIED',
  'INVALID_CREDENTIALS',
  'PLAN_LIMIT_REACHED',
  'FEATURE_NOT_IN_PLAN',
  'INTEGRATION_ERROR',
  'PAYMENT_ERROR',
  'SERVICE_UNAVAILABLE',
  'INTERNAL_ERROR',
] as const;
export type ErrorCode = (typeof ERROR_CODES)[number];

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.enum(ERROR_CODES),
    message: z.string(),
    details: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
    requestId: z.string().optional(),
  }),
});
export type ApiError = z.infer<typeof apiErrorSchema>;
